module.exports = {
	"header": "Fashion brands choses Spotin's technology",
	"date": "2022/05/03",
	"imgSrc": "kristoffer_karlsson_news.jpg",
	"imgAlt": "Kristoffer Karlsson",
	"ingress": "More and more fashion brands showing interest in Luleå-based Spotin's content commerce solution.",
	"sections": [
		{
			"paragraphs": [
				"More and more fashion brands are choosing to distribute their e-commerce to various digital content through the technical solution content commerce. Luleå-based scale-up company Spotin, which delivers the solution, has seen a clear increase in interest from brands over the past six months.",
				"The map for the e-commerce landscape has been redrawn in recent years. This is largely due to the fact that new technology has opened up new opportunities for brands to sell their products and services. As content-driven commerce and social commerce have become a more accepted way for consumers to both discover and shop for products, their demands for a smooth shopping experience have increased at the same time. A survey conducted by Spotin together with Norstat shows that consumers today both want and expect the smoothest route from A to B when shopping online.",
				"Through this new technical solution called content commerce, brands can sell their products directly to digital publishers and content creators via so-called remote checkout, so that consumers do not have to be linked away from the content to another site or platform to complete the purchase."
			],
			"quote": {
				"text": "”Companies are losing huge business opportunities due to shortcomings and limitations with previous technical solutions, and we are delighted to see more and more brands choosing Spotin's solution to distribute their e-commerce and get closer to consumers”",
				"author": "Kristoffer Karlsson",
				"title": "Founder and CEO of Spotin"
			}
		},
		{
			"paragraphs": [
				"Over the past six months, Spotin has integrated a wide range of brands that want to distribute their e-commerce. Some of the brands that have recently jumped on the trend are the jewellery brand Sophie By Sophie and the clothing brand DAY Birger et Mikkelsen, both of which are looking forward to taking their e-commerce to editorial content."
			],
			"quote": {
				"text": "“Being available to our customers when their interest is peaking, and building relationships with new consumers using Spotin and their content commerce solution will be really exciting, we look forward to it”",
				"author": "Sophie Gyllenhammar Mattsson",
				"title": "Founder and designer at Sophie by Sophie"
			}
		},
		{
			"paragraphs": [
				"Christina Exsteen, Creative Director at DAY Birger et Mikkelsen, believes that at DAY Birger et Mikkelsen they value consumers' time and therefore want to give them the shortest and easiest way to their products."
			],
			"quote": {
				"text": "“We want to make life easier for women, while also being inspired. That's why we are happy to be part of a project that combines the two.”",
				"author": "Christina Exsteen",
				"title": "Creative Director at DAY Birger et Mikkelsen"
			}
		},
		{
			"paragraphs": [
				"Sophie by Sophie and DAY Birger et Mikkelsen, together with many other brands, will soon be available to shop directly at selected digital publishers via Spotin."
			]
		}
	]
};


//////////////////
// WEBPACK FOOTER
// ./pages/news/2/article.json
// module id = 15
// module chunks = 0